/*jslint white: true, nomen: true */
/*global angular, $, communityId, planId */
(function () {
  "use strict";

  angular.module("app.microsite").controller("MicrositeFloorplanDetailRevampedCtrl", [
    "$scope",
    "$http",
    "$sce",
    "$timeout",
    "$rootScope",
    "slickConfigService",
    function (
      $scope,
      $http,
      $sce,
      $timeout,
      $rootScope,
      slickConfigService,
    ) {
      $scope.residence = null;
      $scope.planLoaded = false;
      $scope.hasGalleryAssets = true;
      var loadedOnce = false;
      
      $scope.floorplansModal = false;
      $scope.galleryModal = false;

      function formatRange(low, high) {
        let hasLow  = low && low > 0;
        let hasHigh = high && high > 0;

        if (hasLow && hasHigh) {
          return low === high
            ? high.toLocaleString('en-US')
            : `${low.toLocaleString('en-US')}–${high.toLocaleString('en-US')}`;
        } else if (hasLow) {
          return low.toLocaleString('en-US');
        } else if (hasHigh) {
          return high.toLocaleString('en-US');
        } else {
          return "";
        }
      }
      $scope.communityPromise = $http.get(`/api/community/${communityId}?summary=1`, { cache: true }).then(function (response) {
        $scope.community = response.data.community;
        $scope.region = response.data.region;
      });
      
      $scope.communityFloorplanDetailsPromise = $http
        .get(`/api/community/by-floorplan/${communityId}/${planId}`, { cache: true })
        .then(function (response) {
        const result = response.data;
          // $scope.community = result.community;
          $scope.residence = result.residence;
          // $scope.region = result.region;
          
          $scope.floorplans = $scope.residence.floorplans ? $scope.residence.floorplans : false;
          $scope.hasGalleryAssets = $scope.residence.assetImages && $scope.residence.assetImages.length > 0;
          $scope.youMightAlsoLike = result.you_might_also_like;
          $scope.hasYouMightAlsoLike = $scope.youMightAlsoLike && $scope.youMightAlsoLike.length > 0;
          var elevationImages =
            $scope.residence.elevationImages ||
            ($scope.residence.plan && $scope.residence.plan.elevationImages) ||
            [];

          angular.forEach(elevationImages, function (elevationImage) {
            elevationImage.image = elevationImage.img;
            delete elevationImage.img;
          });

          $scope.residence.elevationImages = elevationImages;
          if ($scope.residence.plan) {
            $scope.residence.plan.elevationImages = elevationImages;
          }

          $scope.residence.beds = formatRange($scope.residence.plan.bed_low, $scope.residence.plan.bed_high);
          $scope.residence.baths = formatRange($scope.residence.plan.bath_low, $scope.residence.plan.bath_high);
          $scope.residence.sqft = formatRange($scope.residence.plan.sqft_low, $scope.residence.plan.sqft_high);
          $scope.residence.stories = $scope.residence.plan.floors ? $scope.residence.plan.floors : '2';
          // API can come back with modelHomes or model_homes
          if ($scope.residence.plan.model_homes === undefined) {
            $scope.residence.plan.model_homes =
              $scope.residence.plan.modelHomes;
          }

          angular.forEach(
            $scope.residence.plan.model_homes,
            function (model_home) {
              model_home.elevation = elevationImages[0];
              $scope.imagesLoaded = true;
              loadedOnce = true;
            }
          );

          $scope.hasInteractiveFloorplan = !!$scope.residence.interactive_floorplan_url;

          $scope.hasKitchenVisualizer = !!$scope.residence.kitchen_visualizer_url;
          $scope.kitchenVisualizerThumb = $scope.hasKitchenVisualizer && $scope.residence.visualizerThumb && $scope.residence.visualizerThumb.hd ? $scope.residence.visualizerThumb.hd : '/images/site/global/kitchen_visualizer_avery.gif';

          //Virtual Tour Logic
          let virtualTourUrl = $scope.residence.virtual_tour_url || '';

          if(virtualTourUrl && virtualTourUrl.indexOf('matterport') !== -1){
              const separator = virtualTourUrl.indexOf("?") === -1 ? "?" : "&";
              virtualTourUrl += separator + "play=1";
          }

          $scope.residence.virtualTourTrustedUrl = $sce.trustAsResourceUrl(virtualTourUrl);
          $scope.residence.interactiveFloorplanTrustedUrl = $scope.residence.interactive_floorplan_url ? $sce.trustAsResourceUrl($scope.residence.interactive_floorplan_url) : null;
          $scope.hasVirtualTour = !!$scope.residence.virtual_tour_url;
          
          $scope.galleryStrip = {};
          $scope.planLoaded = true;
        })
        .then(function () {
          $scope.communityName = $scope.residence && $scope.residence.community ? $scope.residence.community.name : "Community";
          $scope.communityUrl = $scope.residence && $scope.residence.community ? $scope.residence.community.url : '#';
          $scope.imagesLoaded = true;
          loadedOnce = true;
          // Gallery Carousel Config & Hero Assets
          $scope.hasGalleryAssets = $scope.residence.assetImages && $scope.residence.assetImages.length > 0;
          $scope.galleryAssets = $scope.residence.assetImages;
          if($scope.residence.plan && $scope.residence.plan.videos && $scope.residence.plan.videos.length > 0){
            $scope.galleryAssets.splice(3,0, $scope.residence.plan.videos[0]);
            $scope.galleryAssets = $scope.galleryAssets.concat($scope.residence.plan.videos.slice(1));
          }
          slickConfigService.modalSlideshow($scope);
          $scope.galleryStrip.heroThumbnail =
            $scope.residence.assetImages &&
            $scope.residence.assetImages.length > 0 &&
            $scope.residence.assetImages[0].image
              ? $scope.residence.assetImages[0].image.hd
              : '';

          
          $scope.galleryStrip.videoFallback =
            $scope.residence.assetImages &&
            $scope.residence.assetImages.length > 3 &&
            $scope.residence.assetImages[3].image
              ? $scope.residence.assetImages[3].image.hd
              : '';
          $scope.galleryStrip.videoThumbnail = 
            $scope.residence.plan &&
            $scope.residence.plan.videos && 
            $scope.residence.plan.videos.length > 0 &&
            $scope.residence.plan. videos[0].image
              ? $scope.residence.plan.videos[0].image.hd
              : $scope.galleryStrip.videoFallback;
          $scope.galleryStrip.virtualTourFallback =
            $scope.residence.assetImages &&
            $scope.residence.assetImages.length > 1 &&
            $scope.residence.assetImages[1].image
              ? $scope.residence.assetImages[1].image.hd
              : '';
          $scope.galleryStrip.virtualTourThumbnail = 
            $scope.residence.virtualTourThumb && $scope.residence.virtualTourThumb.original
              ? $scope.residence.virtualTourThumb.original
              : $scope.galleryStrip.virtualTourFallback;

          $scope.galleryStrip.galleryImageThumbnail =
            $scope.residence.assetImages &&
            $scope.residence.assetImages.length > 2 &&
            $scope.residence.assetImages[2].image
              ? $scope.residence.assetImages[2].image.hd
              : '';

          $scope.galleryStrip.viewAllThumbnail =
            $scope.residence.assetImages &&
            $scope.residence.assetImages.length > 4 &&
            $scope.residence.assetImages[4].image
              ? $scope.residence.assetImages[4].image.hd
              : '';

          $scope.galleryStrip.imageCount = $scope.residence.assetImages.length ? `${$scope.residence.assetImages.length}+` : 'All';

          // Collection Carousel Config
              
          $scope.residence.collectionSlide = slickConfigService.baseConfig(3);
          $scope.residence.collectionSlide.slidesToScroll = 1;
          $scope.residence.collectionSlide.arrows = true;
          $scope.residence.collectionSlide.focusOnSelect = false;

          var slickResponsive = [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                arrows: false,
                dots: true,
              },
            },
          ];

          $scope.residence.collectionSlide.responsive = slickResponsive;

          $scope.residence.collectionSlide.prevArrow = '<button type="button" class="floorplans-slick-btn slick-next"><svg class="icon-angle-left" xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" width="12" height="22.8" viewBox="0 0 12 22.8" enable-background="new 0 0 11.978 22.843" xml:space="preserve"><polygon fill-rule="evenodd" clip-rule="evenodd" points="12 0.5 11.5 0 0.1 11.4 11.5 22.8 12 22.4 1 11.4 "></polygon></svg></button>';
          $scope.residence.collectionSlide.nextArrow = '<button type="button" class="floorplans-slick-btn slick-prev"><svg class="icon-angle-right" xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" width="12" height="22.8" viewBox="0 0 12 22.8" enable-background="new 0 0 11.978 22.843" xml:space="preserve"><polygon fill-rule="evenodd" clip-rule="evenodd" points="0.1 0.5 0.5 0 12 11.4 0.5 22.8 0.1 22.4 11.1 11.4 "></polygon></svg></button>';


          // Elevations Carousel Config
          
          $scope.residence.elevationSlide = slickConfigService.baseConfig(3);
          $scope.residence.elevationSlide.infinite = true;

          $scope.residence.elevationSlide.slidesToScroll = 1;
          if($scope.mobileView) {
            $scope.residence.elevationSlide.dots = true;
            $scope.residence.elevationSlide.arrows = false;
          }

          $scope.residence.elevationSlide.responsive = slickResponsive;

          $scope.residence.elevationSlide.arrows = true;
          $scope.residence.elevationSlide.prevArrow = '<button type="button" class="floorplans-slick-btn slick-next"><svg class="icon-angle-left" xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" width="12" height="22.8" viewBox="0 0 12 22.8" enable-background="new 0 0 11.978 22.843" xml:space="preserve"><polygon fill-rule="evenodd" clip-rule="evenodd" points="12 0.5 11.5 0 0.1 11.4 11.5 22.8 12 22.4 1 11.4 "></polygon></svg></button>';
          $scope.residence.elevationSlide.nextArrow = '<button type="button" class="floorplans-slick-btn slick-prev"><svg class="icon-angle-right" xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" width="12" height="22.8" viewBox="0 0 12 22.8" enable-background="new 0 0 11.978 22.843" xml:space="preserve"><polygon fill-rule="evenodd" clip-rule="evenodd" points="0.1 0.5 0.5 0 12 11.4 0.5 22.8 0.1 22.4 11.1 11.4 "></polygon></svg></button>';

          function addAutoPlay(url) {
            if(url && url.indexOf('matterport') !== -1) {
              const separator = url.indexOf("?") === -1 ? "?" : "&";
              url += separator + "play=1";
            }
            return url;
          };

          $scope.residence.virtualTourCarousel = [];
          
          function addTour(title = "", thumb = "", url, autoplay = false) {
            console.log('title', title, 'thumb', thumb, 'url', url, 'autoplay', autoplay);
            if (url) {
              $scope.residence.virtualTourCarousel.push({
                virtual_tour_title: title,
                virtualTourThumb: thumb,
                virtual_tour_url: $sce.trustAsResourceUrl(
                  autoplay ? addAutoPlay(url) : url
                )
              });
            }
          }
          
          addTour(
            $scope.residence.virtual_tour_title,
            $scope.residence.virtual_tour_thumb,
            $scope.residence.virtual_tour_url,
            true
          );
          
          addTour(
            $scope.residence.virtual_tour_b_title,
            $scope.residence.virtual_tour_b_thumb,
            $scope.residence.virtual_tour_b_url
          );
          
          addTour(
            $scope.residence.virtual_tour_c_title,
            $scope.residence.virtual_tour_c_thumb,
            $scope.residence.virtual_tour_c_url
          );

          $scope.residence.virtualtourSlide = {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            arrows: true,
            swipe: true,
            dots: false,
            focusOnSelect: true,
            initialSlide: 0,
            asNavFor: '#virtual-tour-nav',
            prevArrow: '<button type="button" class="floorplans-slick-btn slick-prev"><svg class="icon-angle-left" xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" width="12" height="22.8" viewBox="0 0 12 22.8" enable-background="new 0 0 11.978 22.843" xml:space="preserve"><polygon fill-rule="evenodd" clip-rule="evenodd" points="12 0.5 11.5 0 0.1 11.4 11.5 22.8 12 22.4 1 11.4 "></polygon></svg></button>',
            nextArrow: '<button type="button" class="floorplans-slick-btn slick-next"><svg class="icon-angle-right" xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" width="12" height="22.8" viewBox="0 0 12 22.8" enable-background="new 0 0 11.978 22.843" xml:space="preserve"><polygon fill-rule="evenodd" clip-rule="evenodd" points="0.1 0.5 0.5 0 12 11.4 0.5 22.8 0.1 22.4 11.1 11.4 "></polygon></svg></button>'
          };
          
          $scope.residence.virtualtourNav = {
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            infinite: false,
            swipeToSlide: true,
            asNavFor: '#virtual-tour-main',
            focusOnSelect: true,
            centerMode: true,
            centerPadding: '0px',
            variableWidth: true,
            responsive: [
              {
                breakpoint: 1024,
                settings: { slidesToShow: 3 }
              },
              {
                breakpoint: 768,
                settings: { slidesToShow: 2 }
              },
              {
                breakpoint: 480,
                settings: { slidesToShow: 1 }
              }
            ]
          };

          $scope.slideChanged = function (event, slick, currentSlide) {
            if (document.activeElement) {
              document.activeElement.blur();
            }
          
            $('#virtual-tour-nav').slick('slickGoTo', currentSlide);
            if (currentSlide !== 0) {
          
              var firstIframe = $('.slick-slide[data-slick-index="0"]:not(.slick-cloned) iframe');
          
              if (firstIframe.length) {
          
                var iframe = firstIframe[0];
                var src = iframe.src;
                iframe.src = '';
                iframe.removeAttribute('src');
                iframe.offsetHeight;
                iframe.src = src.replace('autoplay=1', 'autoplay=0');
              }
            }
          };

          $scope.residence.floorplansSlide = {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,      
            variableWidth: false,
            arrows: true,
            dots: true,
            appendDots: '.floorplan-names',
            prevArrow: '<button type="button" class="floorplans-slick-btn slick-prev"><svg class="icon-angle-left" xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" width="12" height="22.8" viewBox="0 0 12 22.8" enable-background="new 0 0 11.978 22.843" xml:space="preserve"><polygon fill-rule="evenodd" clip-rule="evenodd" points="12 0.5 11.5 0 0.1 11.4 11.5 22.8 12 22.4 1 11.4 "></polygon></svg></button>',
            nextArrow: '<button type="button" class="floorplans-slick-btn slick-next"><svg class="icon-angle-right" xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" width="12" height="22.8" viewBox="0 0 12 22.8" enable-background="new 0 0 11.978 22.843" xml:space="preserve"><polygon fill-rule="evenodd" clip-rule="evenodd" points="0.1 0.5 0.5 0 12 11.4 0.5 22.8 0.1 22.4 11.1 11.4 "></polygon></svg></button>',
            customPaging: function (slider, i){
              var plan = $scope.floorplans[i];
              return '<button type="button">'+ (plan.title || 'Slide ' + (i+1)) +'</button>';
            },
          };
      });  

      $rootScope.$on("modalClose", function () {
        $scope.triggerSlick = false;
        $scope.floorplansModal = false;
        $scope.galleryModal = false;
      });

      $scope.openCarouselModal = function(index, assets){
        $scope.setSlide(index);
        if (assets == 'floorplans'){
          $scope.newAssets = $scope.floorplans ? $scope.floorplans : [];
          $scope.slickLarge.dots = true;
          $scope.slickLarge.swipe = false;
          $scope.slickLarge.draggable = false;
          $scope.slickLarge.customPaging =  function (slider, i){
              var plan = $scope.floorplans[i];
              return '<button type="button">'+ (plan.title || 'Slide ' + (i+1)) +'</button>';
            };
          $scope.floorplansModal = true;
          $scope.galleryModal = false;
        } else {
          $scope.newAssets = $scope.galleryAssets ? $scope.galleryAssets : [];
          $scope.slickLarge.dots = false;
          $scope.floorplansModal = false;
          $scope.galleryModal = true;
        }
      }


      $scope.setSlide = function(num) {
        $scope.slickLarge.initialSlide = num;
        $scope.slickLarge.method = {};
        $scope.slickLarge.event = {
            init: function (event, slick) {
              $scope.currentSlide = num;
            },
            afterChange: function (event, slick, currentSlide, nextSlide) {
              $scope.currentSlide = slick.currentSlide;
            }
        };
        $scope.triggerSlick = true;
      };
    },
  ]);
})();
